import {
  useInitializeBatchForDocument,
  useInitializeContactChanges,
  useInitializeDocument,
  useInitializeDocumentBatchChat,
  useInitializeDocumentBatchUsers,
  useInitializeDocumentCreator,
  useInitializeDocumentFileInfo,
  useInitializeDocumentSummary,
  useInitializeDocumentTypes,
} from './hooks'

interface DocumentInitializationProps {
  documentId: string
}

export const DocumentInitialization: React.FC<DocumentInitializationProps> = ({ documentId }) => {
  useInitializeDocumentTypes()
  useInitializeDocument(documentId)
  useInitializeDocumentCreator()
  useInitializeDocumentSummary(documentId)
  useInitializeContactChanges(documentId)
  useInitializeDocumentFileInfo()
  useInitializeBatchForDocument()
  useInitializeDocumentBatchUsers()
  useInitializeDocumentBatchChat()

  return null
}
